module.exports = __webpack_public_path__ + "static/media/3.6c3e69f0.jpg";